/**
 * Sample Order - New Friends Industries
 *
 * Data-driven 3-step flow (Select Design -> Select Pieces -> Add to Cart).
 * Design and piece data, including real Shopify variant IDs, are rendered
 * into <script type="application/json" data-sample-order-data> by the section
 * based on its "design" blocks. Adding samples uses Shopify's existing cart
 * (/cart/add.js) with the resolved variant IDs.
 */
(function () {
  const sampleOrderRoot = document.querySelector('[data-sample-order]');
  if (!sampleOrderRoot) return;

  let designs = [];
  let currencySymbol = '$';
  const dataScript = document.querySelector('[data-sample-order-data]');
  if (dataScript) {
    try {
      const parsed = JSON.parse(dataScript.textContent);
      designs = Array.isArray(parsed.designs) ? parsed.designs : [];
      if (typeof parsed.currencySymbol === 'string' && parsed.currencySymbol) {
        currencySymbol = parsed.currencySymbol;
      }
    } catch (e) {
      console.error('Sample Order: invalid data payload', e);
    }
  }

  // ---- DEMO FALLBACK: lets Step 2 (the variant grid) render without any
  // configured theme data so the layout can be previewed immediately with 4
  // "Serving Rice" cards. Delete this fallback (and the two helpers below)
  // once real designs are wired up in the Section settings. ----------------
  function mockProductImage(fill, label) {
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600">' +
      '<rect width="100%" height="100%" fill="' + fill + '"/>' +
      '<circle cx="300" cy="300" r="150" fill="none" stroke="#e8e4df" stroke-width="4"/>' +
      '<text x="300" y="300" fill="#6b6b6b" font-size="30" font-family="Georgia" text-anchor="middle" dominant-baseline="middle">' + label + '</text></svg>';
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }
  function buildMockPieces() {
    const fills = ['#efe9e1', '#e6ded0', '#d9d2c9', '#ded3c6'];
    return fills.map(function (fill, i) {
      const key = 'sv_rice_' + i;
      return {
        name: 'Serving Rice',
        image: mockProductImage(fill, 'Serving Rice'),
        price: 50000,
        variantId: key,
        finishes: [
          { name: 'Shine', price: 44200, variantId: key + '_shine', available: true },
          { name: 'Gold', price: 50000, variantId: key + '_gold', available: true },
          { name: 'Matt Shine', price: 44200, variantId: key + '_matt_shine', available: true },
          { name: 'Matt Gold', price: 50000, variantId: key + '_matt_gold', available: true }
        ]
      };
    });
  }
  if (!designs.length) {
    designs = [{
      name: 'Serving Rice',
      image: mockProductImage('#e8e2d8', 'Serving Rice'),
      pieces: buildMockPieces()
    }];
  }
  // ------------------------------------------------------------------------

  const panels = Array.from(sampleOrderRoot.querySelectorAll('[data-step-panel]'));
  const indicators = Array.from(sampleOrderRoot.querySelectorAll('[data-step-indicator]'));

  const designsGrid = sampleOrderRoot.querySelector('[data-designs]');
  const piecesGrid = sampleOrderRoot.querySelector('[data-pieces]');
  const designsEmpty = sampleOrderRoot.querySelector('[data-designs-empty]');
  const nextButton = sampleOrderRoot.querySelector('[data-next-step]');
  const addToCartButton = sampleOrderRoot.querySelector('[data-add-to-cart]');
  const addToCartStep2Button = sampleOrderRoot.querySelector('[data-add-to-cart-step2]');
  const clearSelectionButton = sampleOrderRoot.querySelector('[data-clear-selection]');
  const step2Summary = sampleOrderRoot.querySelector('[data-step2-summary]');
  const step2Price = sampleOrderRoot.querySelector('[data-step2-price]');
  const cartNote = sampleOrderRoot.querySelector('[data-cart-note]');

  const selectedDesignEl = sampleOrderRoot.querySelector('[data-selected-design]');
  const summaryDesignEl = sampleOrderRoot.querySelector('[data-summary-design]');
  const summaryPiecesEl = sampleOrderRoot.querySelector('[data-summary-pieces]');
  const summaryCountEl = sampleOrderRoot.querySelector('[data-summary-count]');
  const summaryTotalEl = sampleOrderRoot.querySelector('[data-summary-total]');

  let currentStep = 1;
  let selectedDesign = null;
  let selectedPieces = {};       // pieceKey -> quantity
  const chosenFinish = {};       // pieceKey -> { name, variantId, price }
  let pieceList = [];            // current design pieces: { key, name, image, finishes }
  let designButtons = [];
  let pieceButtons = [];
  let finishButtons = [];

  const CHECK_SVG =
    '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M3 8.5L6.5 12L13 4.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const PLATE_SVG =
    '<svg class="sample-order__card-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<circle cx="32" cy="30" r="20" stroke="currentColor" stroke-width="2"/>' +
    '<path d="M20 42L14 54M24 42L22 54M44 42L50 54M40 42L42 54M32 30v10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  // Thin divider line used between card sections (price -> FINISH -> quantity).
  function makeDivider() {
    const d = document.createElement('div');
    d.className = 'sample-order__piece-divider';
    d.setAttribute('aria-hidden', 'true');
    return d;
  }

  // Left-side icon for each finish/variant option. Rendered as an outline;
  // CSS fills it solid when the option is selected.
  function makeFinishIcon(name) {
    const span = document.createElement('span');
    span.className = 'sample-order__variant-icon';
    span.setAttribute('aria-hidden', 'true');
    const n = String(name || '').toLowerCase();
    let inner;
    if (n.indexOf('gold') !== -1) {
      // Crown for (Matt) Gold.
      // inner = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">' +
      //   '<path d="M2 12 L3 8 L6 11 L5 8 L8 5.5 L8 10.5 L11 8.5 L12 12 L14 8 L14 12 L10 12 L8 12 L5 12 Z"/></svg>';
      inner = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 1.5 L14 7.5 L8 13.5 L2 7.5 Z"></path></svg>';
    } else {
      // Sparkle for (Matt) Shine.
      inner = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 1.5 L14 7.5 L8 13.5 L2 7.5 Z"></path></svg>';
    }
    span.innerHTML = inner;
    return span;
  }

  function showStep(step) {
    currentStep = step;
    panels.forEach(function (panel) {
      panel.hidden = Number(panel.dataset.stepPanel) !== currentStep;
    });
    indicators.forEach(function (indicator) {
      const index = Number(indicator.dataset.stepIndicator);
      indicator.classList.toggle('is-active', index === currentStep);
      indicator.classList.toggle('is-done', index < currentStep);
    });
    if (typeof sampleOrderRoot.scrollIntoView === 'function') {
      sampleOrderRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function buildDesigns() {
    designsGrid.innerHTML = '';
    designButtons = [];
    if (!designs.length) {
      designsEmpty.hidden = false;
      return;
    }
    designsEmpty.hidden = true;
    designs.forEach(function (design) {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'sample-order__card';
      card.dataset.design = design.name || '';
      card.setAttribute('aria-pressed', 'false');

      const media = document.createElement('span');
      media.className = 'sample-order__card-media';
      if (design.image) {
        const img = document.createElement('img');
        img.src = design.image;
        img.alt = design.name || 'Design';
        img.loading = 'lazy';
        media.appendChild(img);
      } else {
        media.setAttribute('aria-hidden', 'true');
        media.innerHTML = PLATE_SVG;
      }

      const name = document.createElement('span');
      name.className = 'sample-order__card-name';
      name.textContent = design.name;

      const check = document.createElement('span');
      check.className = 'sample-order__card-check';
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML = CHECK_SVG;

      card.appendChild(media);
      card.appendChild(name);
      card.appendChild(check);
      card.addEventListener('click', function () { selectDesign(design); });
      designsGrid.appendChild(card);
      designButtons.push(card);
    });
  }

  function selectDesign(design) {
    selectedDesign = design;
    designButtons.forEach(function (card) {
      const isSelected = card.dataset.design === design.name;
      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
    selectedDesignEl.textContent = design.name;
    buildPieces(design);
    showStep(2);
  }

  function buildPieces(design) {
    selectedPieces = {};
    pieceList = [];
    for (const k in chosenFinish) delete chosenFinish[k];
    finishButtons = [];
    pieceButtons = [];
    piecesGrid.innerHTML = '';
    if (nextButton) nextButton.disabled = true;
    const list = design.pieces || [];
    if (!list.length) {
      piecesGrid.innerHTML = '<p class="sample-order__empty">No pieces are available for this design yet.</p>';
      refreshAll();
      return;
    }
    list.forEach(function (piece, idx) {
      const key = String(piece.variantId || 'p' + idx);
      const finishes = (Array.isArray(piece.finishes) && piece.finishes.length) ? piece.finishes : [];

      // Determine the active (selected) finish: first available, else first.
      let active;
      if (finishes.length) {
        active =
          finishes.find(function (f) {
            return String(f.name || '').toLowerCase() === 'gold' && f.available !== false;
          }) ||
          finishes.find(function (f) { return f.available !== false; }) ||
          finishes[0];
      } else {
        active = { name: '', variantId: piece.variantId, price: piece.price || 0, available: true };
      }
      chosenFinish[key] = {
        name: active.name || '',
        variantId: String(active.variantId || ''),
        price: active.price || 0
      };
      pieceList.push({ key: key, name: piece.name || 'Piece', image: piece.image || '', finishes: finishes });

      const card = document.createElement('article');
      card.className = 'sample-order__piece';
      card.dataset.key = key;

      // Premium two-column card: [media][content], where content is
      // name -> price -> divider -> FINISH grid -> divider -> qty stepper.
      const header = document.createElement('div');
      header.className = 'sample-order__piece-header';
      
      const media = document.createElement('div');
      media.className = 'sample-order__piece-media';

      const body = document.createElement('div');
      body.className = 'sample-order__piece-body';

      const intro = document.createElement('div');
      intro.className = 'sample-order__piece-intro';

      const img = document.createElement('img');
      img.className = 'sample-order__piece-image';
      img.src = piece.image || '';
      img.alt = piece.name || 'Piece';
      img.loading = 'lazy';

      const name = document.createElement('span');
      name.className = 'sample-order__piece-name';
      name.textContent = piece.name;

      const priceEl = document.createElement('span');
      priceEl.className = 'sample-order__piece-price';
      priceEl.textContent = formatPrice(chosenFinish[key].price);

      

      // Quantity control
      const qtyWrapper = document.createElement('div');
      qtyWrapper.className = 'sample-order__piece-qty';
      const btnMinus = document.createElement('button');
      btnMinus.type = 'button';
      btnMinus.className = 'sample-order__piece-qty-btn';
      btnMinus.dataset.key = key;
      btnMinus.setAttribute('aria-label', 'Decrease ' + (piece.name || 'Piece') + ' quantity');
      btnMinus.textContent = '-';
      const qtyDisplay = document.createElement('span');
      qtyDisplay.className = 'sample-order__piece-qty-val';
      qtyDisplay.textContent = '0';
      const btnPlus = document.createElement('button');
      btnPlus.type = 'button';
      btnPlus.className = 'sample-order__piece-qty-btn';
      btnPlus.dataset.key = key;
      btnPlus.setAttribute('aria-label', 'Increase ' + (piece.name || 'Piece') + ' quantity');
      btnPlus.textContent = '+';

      btnMinus.addEventListener('click', function () {
        const current = Number(qtyDisplay.textContent);
        const next = Math.max(0, current - 1);
        qtyDisplay.textContent = next;
        if (next > 0) {
          selectedPieces[key] = next;
        } else {
          delete selectedPieces[key];
        }
        card.classList.toggle('is-selected', next > 0);
        onQuantityChange(key, next);
        refreshAll();
      });
      btnPlus.addEventListener('click', function () {
        const next = Number(qtyDisplay.textContent) + 1;
        qtyDisplay.textContent = next;
        selectedPieces[key] = next;
        card.classList.add('is-selected');
        onQuantityChange(key, next);
        refreshAll();
      });
      
      media.appendChild(img);

      // Corner badge: a small diamond-outline icon in the accent color.
      const badge = document.createElement('span');
      badge.className = 'sample-order__badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.innerHTML =
        '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M8 1.5 L14 7.5 L8 13.5 L2 7.5 Z"/></svg>';
      // media.appendChild(badge);

      
      intro.appendChild(name);
      intro.appendChild(priceEl);
      
      header.appendChild(media);
      header.appendChild(intro);
      
      card.appendChild(header);

      body.appendChild(makeDivider());
      card.appendChild(body);
      
      // Finish selector — rendered ONLY when the real product has finishes.
      if (finishes.length) {
        const finishGroup = document.createElement('div');
        finishGroup.className = 'sample-order__piece-finishes';
        const label = document.createElement('span');
        label.className = 'sample-order__piece-finish-label';
        label.textContent = 'Finish';
        // finishGroup.appendChild(label);
        const options = document.createElement('div');
        options.className = 'sample-order__piece-finish-options';
        
        // Select Shine by default
        const defaultFinish = finishes.find(function (finish) {
          return finish.name === 'Shine';
        });

        if (defaultFinish) {
          chosenFinish[key] = {
            name: defaultFinish.name || '',
            variantId: String(defaultFinish.variantId || ''),
            price: defaultFinish.price || 0
          };

          // Set initial price
          priceEl.textContent = formatPrice(chosenFinish[key].price);
        }

        finishes.forEach(function (finish, fi) {
          const fbtn = document.createElement('button');
          fbtn.type = 'button';
          fbtn.className = 'sample-order__piece-finish-option';
          fbtn.dataset.key = key;
          fbtn.dataset.fi = String(fi);

          const isSelected =
            chosenFinish[key] &&
            chosenFinish[key].variantId === String(finish.variantId);

          fbtn.setAttribute(
            'aria-label',
            'Select ' + finish.name + ' finish for ' + (piece.name || 'Piece')
          );

          fbtn.setAttribute(
            'aria-pressed',
            isSelected ? 'true' : 'false'
          );

          const variantIcon = makeFinishIcon(finish.name);

          variantIcon.style.color = getFinishColor(finish.name);
          variantIcon.style.fill = getFinishColor(finish.name);

          const variantLabel = document.createElement('span');
          variantLabel.className = 'sample-order__variant-label';

          const nameLine = document.createElement('strong');
          nameLine.textContent = finish.name || '';

          const priceLine = document.createElement('span');
          priceLine.textContent = finish.price
            ? formatPrice(finish.price)
            : '';

          variantLabel.appendChild(nameLine);
          variantLabel.appendChild(priceLine);

          const checkBadge = document.createElement('span');
          checkBadge.className = 'sample-order__variant-badge';
          checkBadge.setAttribute('aria-hidden', 'true');
          checkBadge.innerHTML = CHECK_SVG;

          fbtn.appendChild(variantIcon);
          fbtn.appendChild(variantLabel);
          fbtn.appendChild(checkBadge);

          if (finish.available === false) {
            fbtn.disabled = true;
          }

          // Select Shine initially
          if (isSelected) {
            fbtn.classList.add('is-selected');
          }

          fbtn.addEventListener('click', function () {
            chosenFinish[key] = {
              name: finish.name || '',
              variantId: String(finish.variantId || ''),
              price: finish.price || 0
            };

            options
              .querySelectorAll('.sample-order__piece-finish-option')
              .forEach(function (ob) {
                const fRef = finishes[Number(ob.dataset.fi)];

                const sel =
                  chosenFinish[key].variantId === String(fRef.variantId);

                ob.classList.toggle('is-selected', sel);
                ob.setAttribute(
                  'aria-pressed',
                  sel ? 'true' : 'false'
                );
              });

            // Update price after clicking another finish
            priceEl.textContent = formatPrice(chosenFinish[key].price);

            onVariantChange(key, finish.variantId);
            refreshAll();
          });

          options.appendChild(fbtn);
          finishButtons.push(fbtn);
        });
        finishGroup.appendChild(options);
        body.appendChild(finishGroup);
        body.appendChild(makeDivider());
      }

      // Compact quantity stepper lives at the bottom of the content column.
      body.appendChild(qtyWrapper);
      qtyWrapper.appendChild(btnMinus);
      qtyWrapper.appendChild(qtyDisplay);
      qtyWrapper.appendChild(btnPlus);
      piecesGrid.appendChild(card);
      pieceButtons.push(card);
    });
    refreshAll();
  }

  function getFinishColor(finishName) {
    const name = (finishName || '').toLowerCase().replace(/\s+/g, '');

    if (name === 'shine') return '#D9D9D9';
    if (name === 'gold') return '#D4AF37';
    if (name === 'mattshine') return '#A8A8A8';
    if (name === 'mattgold') return '#B89B4A';

    return '#999999';
  }

  // Hooks the parent step-2 page can attach (window.onSampleOrderQuantityChange
  // / window.onSampleOrderVariantChange) to recompute its own sample summary.
  function onQuantityChange(productKey, qty) {
    if (typeof window.onSampleOrderQuantityChange === 'function') {
      window.onSampleOrderQuantityChange(productKey, qty);
    }
  }
  function onVariantChange(productKey, variantId) {
    if (typeof window.onSampleOrderVariantChange === 'function') {
      window.onSampleOrderVariantChange(productKey, variantId);
    }
  }

  function refreshAll() {
    renderSummary();
    updateStep2Summary();
    updateAddToCartState();
  }

    function updateAddToCartState() {
    const hasSelection = Object.values(selectedPieces).some(function (qty) { return qty > 0; });
    if (nextButton) nextButton.disabled = !hasSelection;
    if (addToCartStep2Button) addToCartStep2Button.disabled = !hasSelection;
    // if (step2Summary) step2Summary.hidden = !hasSelection;

    const step2Indicator = document.querySelector(
        '.sample-order__progress-item[data-step-indicator="2"]'
    );

    const step3Indicator = document.querySelector(
        '.sample-order__progress-item[data-step-indicator="3"]'
    );

    if (step2Summary) {
        step2Summary.hidden = !hasSelection;

        if (hasSelection) {
            // Activate Step 3
            step3Indicator?.classList.add('is-active');

            // Deactivate Step 2
            step2Indicator?.classList.remove('is-active');
        } else {
            // Activate Step 2
            step2Indicator?.classList.add('is-active');

            // Deactivate Step 3
            step3Indicator?.classList.remove('is-active');
        }
    }

    updateStep2Summary();
  }

  function updateStep2Summary() {
    if (!step2Price) return;
    let totalQty = 0;
    let totalCents = 0;
    for (const key in selectedPieces) {
      const qty = selectedPieces[key];
      if (qty > 0) {
        totalQty += qty;
        const info = chosenFinish[key] || { price: 0 };
        totalCents += qty * (info.price || 0);
      }
    }
    if (totalQty === 0) {
      step2Price.textContent = 'No pieces selected';
    } else {
      const content = '<div class="price">' + formatPrice(totalCents) + '</div><div class="piece-content"> ' + totalQty + ' piece' + (totalQty !== 1 ? 's' : '') + ' selected</div>';
      step2Price.innerHTML = content;
    }
  }

  function formatPrice(cents) {
    const value = (cents || 0) / 100;
    const hasDecimals = Math.round(value * 100) % 100 !== 0;
    const parts = value.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return currencySymbol +'.'+ parts[0] + (hasDecimals ? '.' + parts[1] : '');
  }

  function renderSummary() {
    const designName = selectedDesign ? selectedDesign.name : '—';
    summaryDesignEl.textContent = designName;

    let totalCents = 0;
    let totalQty = 0;
    let piecesHtml = '';

    for (const key in selectedPieces) {
      const qty = selectedPieces[key];
      if (qty > 0) {
        totalQty += qty;
        const meta = pieceList.find(function (p) { return p.key === key; });
        const info = chosenFinish[key] || { price: 0, name: '' };
        totalCents += qty * (info.price || 0);
        const pieceName = meta ? meta.name : 'Piece';
        const finishHtml = (info.name && info.name !== '') ? ' <span class="piece-finish">(' + info.name + ')</span>' : '';
        piecesHtml += '<li><span class="piece-name">' + pieceName + '</span>' + finishHtml + ' × ' + qty + '</li>';
      }
    }

    summaryCountEl.textContent = totalQty;
    if (summaryTotalEl) {
      summaryTotalEl.textContent = formatPrice(totalCents);
    }

    summaryPiecesEl.innerHTML = totalQty > 0 ? '<ul>' + piecesHtml + '</ul>' : '—';
  }

  function showNote(message, isError) {
    cartNote.textContent = message;
    cartNote.classList.toggle('is-error', !!isError);
    cartNote.hidden = false;
  }

    function addToCart(redirect) {
    const entries = [];
    for (const key in selectedPieces) {
      const qty = selectedPieces[key];
      if (qty > 0) {
        const info = chosenFinish[key] || {};
        entries.push({ id: String(info.variantId || ''), qty: qty });
      }
    }
    if (!entries.length) return;
    addToCartButton.disabled = true;
    addToCartButton.classList.add('is-loading');
    if (addToCartStep2Button) {
      addToCartStep2Button.disabled = true;
      addToCartStep2Button.textContent = 'Adding to cart...';
      addToCartStep2Button.classList.add('is-loading');
    }
    cartNote.hidden = true;

    const formData = new FormData();
    entries.forEach(function (entry) {
      formData.append('items[][id]', entry.id);
      formData.append('items[][quantity]', String(entry.qty));
    });
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
    }
    formData.append('sections_url', window.location.pathname);

    const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (res) {
        if (res.status) {
          showNote(res.description || res.message || 'Could not add samples to your cart.', true);
          return;
        }
        // Refresh Dawn cart UI using the same pattern as standard-actions-override.js
        // so the cart notification/drawer updates to show the new items,
        // while preserving any items the customer already had in their cart.
        if (typeof refreshDawnCartUI === 'function') {
          try { refreshDawnCartUI(); } catch (err) { /* ignore */ }
        } else {
          // fallback: manually refresh cart sections + pubsub
          const sectionsToRender = new Set();
          const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
            const entries = cartEl.getSectionsToRender();
            for (const e of entries ?? []) {
              const sectionId = e.section ?? e.id;
              if (sectionId) sectionsToRender.add(sectionId);
            }
          }
          // also refresh the header cart bubble
          const bubble = document.querySelector('#cart-icon-bubble');
          if (bubble) sectionsToRender.add('cart-icon-bubble');
          if (sectionsToRender.size) {
            const sectionsQuery = [...sectionsToRender].map(function (id) { return 'sections=' + id; }).join('&');
            const url = (window.routes && window.routes.cart_url) || '/cart';
            fetch(url + '.js?' + sectionsQuery, { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cartData) {
                if (cartData?.sections) {
                  for (const [id, info] of Object.entries(cartData.sections)) {
                    const mount = document.getElementById(id);
                    if (mount && typeof mount.replaceChildren === 'function') {
                      const selector = info.extractSelector || '.shopify-section';
                      const source = new DOMParser().parseFromString(cartData.sections[id], 'text/html').querySelector(selector);
                      if (source) mount.replaceChildren(...source.childNodes);
                    }
                  }
                }
                // publish cart-update so Dawn subscribers (cart-notification, cart-drawer) react
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                  try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sample-order', cartData: cartData }); } catch (err) { /* ignore */ }
                }
              });
          }
        }
        showNote('Samples added to your cart.', false);
        if (redirect) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { showNote('Something went wrong adding samples to your cart.', true); })
      .finally(function () {
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('is-loading');
        // if (addToCartStep2Button) {
        //   addToCartStep2Button.disabled = false;
        //   addToCartStep2Button.classList.remove('is-loading');
        // }
      });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      cartNote.hidden = true;
      renderSummary();
      showStep(3);
    });
  }

  addToCartButton.addEventListener('click', function (event) {
    event.preventDefault();
    addToCart();
  });

  if (clearSelectionButton) {
    clearSelectionButton.addEventListener('click', function () {
      selectedPieces = {};
      pieceButtons.forEach(function (button) {
        button.classList.remove('is-selected');
        const qtyDisplay = button.querySelector('.sample-order__piece-qty-val');
        if (qtyDisplay) qtyDisplay.textContent = '0';
      });
      renderSummary();
      updateAddToCartState();
      updateStep2Summary();
    });
  }

  if (addToCartStep2Button) {
    addToCartStep2Button.addEventListener('click', function (event) {
      event.preventDefault();
      addToCart(true); // redirect after add
    });
  }

  sampleOrderRoot.querySelectorAll('[data-back-to]').forEach(function (button) {
    button.addEventListener('click', function () {
      showStep(Number(button.dataset.backTo));
    });
  });

  renderSummary();
  buildDesigns();
  showStep(1);
})();